const COVERIMAGES = [
  {
    id: "1",
    folder: "mytheresa",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283412/fgkqmws6vq5lytkdt5zt.jpg",
    title: "My Theresa Lookbook",
    noOfItems: 10,
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283412/fgkqmws6vq5lytkdt5zt.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283412/ieg3ujxheobotivdxfm0.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283414/fb9lfgdsarovpeq3lwjt.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283417/l6rbrxv3mq5bfwymogma.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283418/theywdfta0owxwfuknv5.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283419/xaru4egornotlrfcgj0v.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283423/d3e4maxqfbdasdflraly.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283424/g8qvshpjmbri90ywsftz.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283426/chubb7u8dn6hczefkmyc.jpg",
    ],
  },
  {
    id: "2",
    folder: "femalecover",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283036/tejv2giqj0alvnbs6xup.jpg",
    title: "FEMALE Cover Story",
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283036/tejv2giqj0alvnbs6xup.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283036/jnsrpn2b4lgxiazivzx6.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283035/leum72tja2hgevwmgtxk.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283033/as3oxz1fqt1rm7cklz49.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283032/bxw2bm6krcxt7s37qitl.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283031/qfz2fffchs8oqfs5dm1v.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283031/cbxyhyt7kfgg8gsmmdwx.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283030/bcfkcfdt1mwsgxhsih9v.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283030/swhme3og8ul6ctngdw4f.jpg",
    ],
  },
  {
    folder: "loreal",
    path: "https://res.cloudinary.com/de1zyaayq/video/upload/v1764283712/walking_thkgdv.mov",
    title: "L'Oréal Defilé 2024",
    filter: "runway",
    images: [
      "https://res.cloudinary.com/de1zyaayq/video/upload/v1764283712/walking_thkgdv.mov",
    ],
  },
  {
    folder: "emporio",
    path: "https://res.cloudinary.com/de1zyaayq/video/upload/v1764283021/IMG_0920_gwfysn.mp4",
    title: "Emporio Armani",
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283018/xvi7v1qozjqegfhouanq.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283017/gi7qob37ude5x9z4cozp.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283016/fozp84rhreybyftotk3s.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283015/tfbrmp16oehdqq0dcsfm.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283020/lbkrqb1pcym7cynpebfe.jpg",
      "https://res.cloudinary.com/de1zyaayq/video/upload/v1764283021/IMG_0920_gwfysn.mp4",
      "https://res.cloudinary.com/de1zyaayq/video/upload/v1764283025/IMG_0922_ay1fb0.mov",
    ],
  },
  {
    folder: "alain",
    path: "https://res.cloudinary.com/de1zyaayq/video/upload/v1764282598/ALAINPAUL_k8xryc.mp4",
    title: "Alain Paul",
    filter: "runway",
    images: [
      "https://res.cloudinary.com/de1zyaayq/video/upload/v1764282598/ALAINPAUL_k8xryc.mp4",
    ],
  },
  {
    folder: "harpers2",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283119/jjnqphj2lylmlw5tfvzl.jpg",
    title: "Harpers Bazaar",
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283119/jjnqphj2lylmlw5tfvzl.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283119/zoinsqotodafs9pdk60m.jpg",
    ],
  },
  {
    folder: "jeannefriot",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283184/p4hosoopnnzb2nqxodfe.webp",
    title: "Jeanne Friot",
    filter: "runway",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283184/p4hosoopnnzb2nqxodfe.webp",
      "https://res.cloudinary.com/de1zyaayq/video/upload/v1764283191/Jeanne_Friot_gyyjhz.mov",
    ],
  },
  {
    folder: "sumo",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283661/awq3souxvtpjgqsvrfjm.png",
    title: "SUMO x SO Paris",
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283661/awq3souxvtpjgqsvrfjm.png",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283662/mxkjlpvsjqp4iqjelisl.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283663/fxsykwofyzlrfcdvaftc.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283667/djdzavbcfbz11touagms.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283668/edr0x2ezn7x8cwppx8wk.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283671/pmy5fwatcm8jv1tpj5g5.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283672/up6glhv88m8ra6fbxwdj.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283676/uraogmbbptou6xslnevh.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283678/gt16i5rgzyzfcbjzrdyy.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283681/crb5paarx3qjgcf67cai.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283683/esj8s9zr8qoanaclhodc.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283683/vig8nezndhsfhk0kukyc.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283688/oadpxsakwymiocybwycy.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283689/thl0nps8mmo9zmmrde6b.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283689/nfiprx2zo3vtfeb8vslv.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283694/jt1rjlai9ccy0no7t9zh.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283696/xwgoxly0shhyac1ntxi0.jpg",
    ],
  },
  {
    folder: "newbalance",
    path: "https://res.cloudinary.com/de1zyaayq/video/upload/v1764283427/e17a24eda82a4b51b29bb937347a5895_plpc6u.mp4",
    title: "New Balance",
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/video/upload/v1764283427/e17a24eda82a4b51b29bb937347a5895_plpc6u.mp4",
    ],
  },
  {
    folder: "wonderland",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283711/ze1i4wupouocprr6bni0.jpg",
    title: "Wonderland",
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283711/ze1i4wupouocprr6bni0.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283717/i0y6uipvr1vc5wf4vwqw.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283718/y6rd5a2el2gq8lnp8czj.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283712/li6zxsauqk8hbdtqyz3j.jpg",
    ],
  },
  {
    folder: "zalando",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284341/xbfiaklvupb8g1lfr3is.webp",
    title: "Zalando",
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284341/xbfiaklvupb8g1lfr3is.webp",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284339/uvvomaplmbaos0gyvhw5.webp",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284338/b6wyqjld3xtk6gdfaupb.webp",
    ],
  },
  {
    folder: "agnes",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284358/q08brcx01mfvtgq9qt82.jpg",
    title: "agnés b.",
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284358/q08brcx01mfvtgq9qt82.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284359/ujg2mpo7ttaqzcvww2ec.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284356/s4tjl9u8feziffzqgpqa.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284355/tou7xwouyvowmgt11jpt.jpg",
    ],
  },
  {
    id: "3",
    folder: "one-magazine",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283487/bcgvzfplvns1f3e9lojg.jpg",
    title: "One Magazine",
    noOfItems: 9,
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283487/bcgvzfplvns1f3e9lojg.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283488/dqdanrnfkkn74khb0hr1.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283479/m91mwk8qgaukayi5hmi6.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283478/gid8tphbrthahxpxdxvk.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283475/qnxd8fngehtvyycrbxgs.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283474/co9mhrfldur9uklnwxgu.jpg",
    ],
  },
  {
    id: "4",
    folder: "icon-april-21",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283167/pdinxprcrsyozpzp2az0.jpg",
    title: "Icon Magazine",
    noOfItems: 1,
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283167/pdinxprcrsyozpzp2az0.jpg",
    ],
  },
  {
    id: "5",
    folder: "sabrina-goh",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283529/ykybxyu8huio7hnw2o48.jpg",
    title: "Sabrina Goh",
    noOfItems: 13,
    filter: "ecommerce",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283529/ykybxyu8huio7hnw2o48.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283528/fftwqa6sxlwsn3nbpjb9.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283527/qq4dunnrq4cabyflhmet.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283520/idvxkwaj0qhbedszq4ku.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283519/yefuqtn8zbi90usxnmor.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283534/nbayledsn1zfmv9yo5su.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283535/iuxhwlodf51vmz9ysa9g.jpg",
    ],
  },
  {
    id: "6",
    folder: "pin-prestige-nov-21",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283508/wafxwpmjn7dtuboqyqds.jpg",
    title: "PIN Prestige Magazine Nov 2021",
    noOfItems: 2,
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283507/tybwzgqkfnypugpm4h9c.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283508/wafxwpmjn7dtuboqyqds.jpg",
    ],
  },
  {
    id: "7",
    folder: "icon-june-21",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283176/ayujpmtaw8dxosjkgzu7.jpg",
    title: "Icon Magazine June 2021 Issue",
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283176/ayujpmtaw8dxosjkgzu7.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283181/rxqjntvwtarjw9t8w3zg.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283176/jpfwoil6peesfuijm04o.jpg",
    ],
  },
  {
    id: "8",
    folder: "jw-anderson",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283200/kk2m88qeusqnkqkyncqq.jpg",
    title: "J.W Anderson F/W London Fashion Week",
    filter: "runway",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283200/kk2m88qeusqnkqkyncqq.jpg",
    ],
  },
  {
    id: "9",
    folder: "nuyou-mar-21",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283433/buj005yst53bsspftu3m.jpg",
    title: "NUYOU Magazine March 2021 Issue",
    noOfItems: 4,
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283433/buj005yst53bsspftu3m.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283435/rbzevcso0ufdzo0myrod.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283432/uxm3qqr1litfshnows9s.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283431/nxlvq6rsk4x1zoqdtiup.jpg",
    ],
  },
  {
    id: "10",
    folder: "pin-prestige-may-21",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283502/bighoaj7y31abm7domkh.jpg",
    title: "PIN Prestige May 2021",
    noOfItems: 8,
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283502/bighoaj7y31abm7domkh.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283501/uq0ukb6b77xugakxdkbw.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283498/yoxrkncl8amaysflnwwr.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283497/ywcpzn3dqybjuha5tvby.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283496/uinlzdguokdeusvgpqmn.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283493/tlmtrluoymz0vww0mpjn.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283492/tlyky5jahvmfxtysxaia.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283491/oqxf27mqlebbasskor2c.jpg",
    ],
  },
  {
    id: "12",
    folder: "holzweiler-lookbook",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283157/dwzynjuhgehbumgx9c7x.jpg",
    title: "Holzweiler Lookbook",
    noOfItems: 19,
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283161/nymzmsjiqaguqwe85v5n.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283160/jry7epljraz9bobhudha.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283159/vzo0wyrsb4r4vcsozenz.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283157/dwzynjuhgehbumgx9c7x.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283157/ye2sgvaffeybuo08vayx.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283156/wtoxnx6zhahgnlrx9crb.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283154/lt7fbol7p5m8ldzikc1m.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283153/nycpvwish2vlgwk2gwbq.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283152/f8zl0nukgg5i02ect4sv.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283150/k4972vjrfelckvlyysfg.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283149/eduzxidkh49krtnvrwqe.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283148/nywjs4jszuydwmoywpdn.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283147/z4utwcha9xnvd8ormmey.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283147/weghfd1dyd4s2tqngwos.jpg",
      "https://res.cloudinary.com/de1zyaayq/video/upload/v1764283164/IMG_0919_xwt2ci.mp4",
    ],
  },
  {
    id: "13",
    folder: "odalisque",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283463/l13wigo1oktiik4wt4sg.jpg",
    title: "Odalisque Magazine",
    noOfItems: 16,
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283463/l13wigo1oktiik4wt4sg.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283471/aabbyzixqmlob9i9olwd.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283470/jokghn1b1vf7frrirxdb.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283468/dlbbfbuqpgun7olcm6vy.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283466/dhljsy61qjytr2mhi3xd.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283465/gdlhko0q4pbxmrxvrlrh.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283462/stvx2x5tmht9x0iktb2f.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283461/bqirave4mdgynxb9wubb.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283457/ns3u6l1stjfaj9vs30il.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283456/j6wf2xhc6nij5gujgmox.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283456/agocggher3w033bxewrz.jpg",
    ],
  },
  {
    id: "14",
    folder: "nuyou-beauty",
    path: "/images/cover/14.jpg",
    title: "NUYOU Magazine Beauty",
    noOfItems: 4,
    filter: "editorial",
  },
  {
    id: "15",
    folder: "the-peak",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283706/hobmtmkcvbawqb1hyrcx.jpg",
    title: "The Peak Magazine",
    noOfItems: 5,
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283706/hobmtmkcvbawqb1hyrcx.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283707/fk6yzgwsytayeqqrszcw.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283704/yliiqcavku3uvgtapi0c.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283699/ajkk4oxtmpldpifgjofg.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283698/oejmlyennjevwtiburwr.jpg",
    ],
  },
  {
    id: "16",
    folder: "icon-mar-2021",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283170/j33hheaa7ddvy2ul4spi.jpg",
    title: "Icon Magazine",
    noOfItems: 5,
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283170/j33hheaa7ddvy2ul4spi.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283169/iretrla5zc1mbyzltcaq.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283171/s7bnqds394wdrkkabanh.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283172/ljhprvibhpj6vcvk61z9.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283172/hylmo7bzfu1nemubbvjp.jpg",
    ],
  },
  {
    id: "17",
    folder: "eileen",
    path: "/images/cover/17.jpg",
    title: "LASALLE Graduation Project",
    noOfItems: 21,
    filter: "lookbook",
  },
  {
    folder: "test",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284301/mfdgvdnhkfszgufqvmgt.jpg",
    title: "Test",
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284301/mfdgvdnhkfszgufqvmgt.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284302/ghwbdd0vkxvo9r18bamb.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284303/idmv1dqizjylaib4vap3.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284305/dwpiqv6xosoihsp3vn1z.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284307/zenwuxlnntqoct00a1no.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284309/x9gxldsyrempzvaj2bwr.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284309/vf9j2gcyoa1bfkbzrf6v.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284312/l7mbfjrdxcr5njrnee3n.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284314/ctm73xwkkfzim7kiu0bc.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284315/rqrg9ddtwmcxafsj3vi5.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284317/lfhwbkuoaw0fbjhkechf.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284318/rabvj7ou2o5jzzti1qj4.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284320/jvbxiczgt0vollske6vn.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284322/i01danufkq1nxno4wcpl.jpg",
    ],
  },
  {
    folder: "yoox",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283728/mr2svdnh0z5ji8gyrfuq.jpg",
    title: "YOOX Milan",
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283728/mr2svdnh0z5ji8gyrfuq.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283725/lfdlpy9z2dv7uuwnm8dc.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283722/hj0r7ucaobs9nnnntrk4.jpg",
      "https://res.cloudinary.com/de1zyaayq/video/upload/v1764283724/yoox-video_e64d7d.mp4",
    ],
  },
  {
    folder: "sicky",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283591/uupumgmonkmi1uomthk6.jpg",
    title: "Sicky Magazine",
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283591/uupumgmonkmi1uomthk6.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283599/hgbxfp1xzzamizwlyynd.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283598/ygzbksbv62aknpjnc7om.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283595/c3xrqtpwlv76eyslks6b.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283594/vi9q51plqdwpn5d6yotn.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283591/p1reofmf4dskewsvlf3q.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283588/rxxxeopicquhrvcrnwad.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283587/ydebuixuzjas4ikipces.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283583/rwh8uyzyuaulevhmdsiu.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283582/mdpj8phqdhodp79jydpu.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283581/mryecgxs603gugdr2rvf.jpg",
    ],
  },
  {
    folder: "renecaovilla",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283514/dkxhsa1o0t2gorw1e86d.jpg",
    title: "Rene Caovilla by Nima Benati",
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283514/dkxhsa1o0t2gorw1e86d.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283516/auajudbvyslnxgfnu8zq.jpg",
    ],
  },
  {
    folder: "ottolinger",
    path: "https://res.cloudinary.com/de1zyaayq/video/upload/v1764283508/OTTOLINGER_ioma83.mp4",
    title: "Ottolinger",
    filter: "runway",
    images: [
      "https://res.cloudinary.com/de1zyaayq/video/upload/v1764283508/OTTOLINGER_ioma83.mp4",
    ],
  },
  {
    folder: "nuyoubeauty",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283436/g4pbkev62xgafgomhini.jpg",
    title: "NUYOU Beauty",
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283437/ndr63p4hodakdsthqtvy.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283436/g4pbkev62xgafgomhini.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283440/rjdemarxarvoy7zimhuc.jpg",
    ],
  },
  {
    folder: "MLtest",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283408/ssscd3rw5og0zvvdlcml.jpg",
    title: "Test",
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283408/ssscd3rw5og0zvvdlcml.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283411/qbmf03qfeqjmoddia7vk.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283404/kn39fbk8mo8ti2zzoh1w.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283404/bc2dapvcdrqbgjip54i9.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283402/z4flwwkov0f6hzjko6jz.jpg",
    ],
  },
  {
    folder: "lsp",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283396/ruyxecexxejpdjcz3ssy.jpg",
    title: "Lagos Space Programme",
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283396/ruyxecexxejpdjcz3ssy.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283399/iq3dqrrni4fzjzgaxz4b.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283394/uzkj80esaml7kaalvndz.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283397/tpcb09detfjrzq2lmbwm.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283392/a5p3hhacmh4gkzz6y7bi.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283389/pzei1drca7vfi90wws6z.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283391/omplv3mjfqsffdioy1sj.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283388/dfnipiujvrcenxkcwkom.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283387/g6vnbxcizb1j8kw0uigb.jpg",
    ],
  },
  {
    folder: "lofficiel",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283242/rvf6wxev4wsvgzgbvf3d.jpg",
    title: "L'Officiel Magazine",
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283242/rvf6wxev4wsvgzgbvf3d.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283241/ljgkiuqrhvnvpp74n9bp.jpg",
    ],
  },
  {
    folder: "kiko",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283229/mhs9kakjv34dykgdezgl.jpg",
    title: "Kiko Kostadinov",
    filter: "runway",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283229/mhs9kakjv34dykgdezgl.jpg",
      "https://res.cloudinary.com/de1zyaayq/video/upload/v1764283221/show_hbwf5z.mp4",
    ],
  },
  {
    folder: "herworldfashion",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283131/crv8s2ftcxli9yr7eult.avif",
    title: "Her World Magazine",
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283131/crv8s2ftcxli9yr7eult.avif",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283135/esqoio0lhcczkj6ufwa7.avif",
    ],
  },
  {
    folder: "herworldbeauty",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283132/dszypfas5uxvnewx215w.jpg",
    title: "Her World Beauty",
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283132/dszypfas5uxvnewx215w.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283131/trpctlmjdh70f4eejz4s.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283133/bqsf9uxy7lpjmssylkdn.jpg",
    ],
  },
  {
    folder: "harpers",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283120/mzpxe0o7y2spoazgafl8.jpg",
    title: "Harpers Bazaar",
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283120/mzpxe0o7y2spoazgafl8.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283121/s9jr6d4q3wuf1kdiyscx.jpg",
    ],
  },
  {
    folder: "fraulein",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283116/rpspng3tg0sffj4upcyg.jpg",
    title: "Fraulein Magazine",
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283116/rpspng3tg0sffj4upcyg.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283116/s1gzhplfgufig8t4kw7z.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283116/iu6mu1f7g8zfkwo2tvo7.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283113/avnfdduuly7nuu1nngqa.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283112/fqwqm4mqmwxgdsqgfi9x.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283112/xcxxscy5fjreth3kpajt.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283111/tu3lo3wddej1ruhmgnxz.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283111/zqdmh9swmemt74f0bjmp.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283108/etr8yj5q3spwszndnfcs.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283108/u1ainporlp3vqlqnmyth.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283108/gzncgejyx0afassofyzj.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283107/vovennrpk6vj5hbycx92.jpg",
    ],
  },
  {
    folder: "ftest",
    path: "https://res.cloudinary.com/de1zyaayq/video/upload/v1764283050/2025_01_06_CHLOE-LAU_V1_4K_H265_MP4_mbyiig.mp4",
    title: "Test",
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/video/upload/v1764283050/2025_01_06_CHLOE-LAU_V1_4K_H265_MP4_mbyiig.mp4",
    ],
  },
  {
    folder: "female",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283040/va1ypicqufsleubbxmku.jpg",
    title: "FEMALE Magazine",
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283040/va1ypicqufsleubbxmku.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283038/talu0fwb9hxvqjxv4vxe.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283039/l33khbovb0bojdndm8ah.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283037/gl6gevm5eypngoy0cest.jpg",
    ],
  },
  {
    folder: "drykorn",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282679/czpkfm8cklkhgiafltji.jpg",
    title: "DRYKORN",
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282679/czpkfm8cklkhgiafltji.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282678/gljsfkx7bcwu99kuic1l.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282678/hsdidbqtrhhit0ihqhtt.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282679/ktukmeontkecynv1kohz.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283001/tc48v97yicedsnkjwrsq.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283002/f21dfipwgvbcm4m1om8r.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283002/adyagossrfb4yjarte0e.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283002/zusr1nc0we9sfkn8hskr.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283003/etgsdiod4lirvvjjntda.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283003/tl74l9yrj2sqv51yffiv.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283003/t8et9mbq9f2xuihbzjmd.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283006/otmnf5qce7nrrbwwoikh.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283006/k4mdwaysetbmaemx7pxo.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283007/in9skov7mw6evojfbsci.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283008/ynymqackll0zhiqbolwm.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283010/ghan5ihqkwo2exl1ku0n.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283011/rwtjqo7hrflivmhwzkrj.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283011/pa7bnq9argr0lzfk5llg.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283012/hboqlqaazamqwdjebbfe.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283012/bvhzu6lqh14fjkkxahn0.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764283013/tr2jh2i6lh5rsjsh4too.jpg",
    ],
  },
  {
    folder: "citizenk",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282671/kdsfjkznojldcf2zm64y.jpg",
    title: "Citizen K Magazine",
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282671/kdsfjkznojldcf2zm64y.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282672/xnjhrwoea6xqsazdy74r.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282672/ko4i0ix1damgrwwvjrx2.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282672/qq6xrzrhexzfelc7azug.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282674/qk3wd22tttiro6hpf289.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282675/omj6y3cshtrg9ohdcz8t.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282675/dxpdgrf072kjfceycwtk.jpg",
    ],
  },
  {
    folder: "cheak",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282659/l8op8gnx71mmhqgbbdrh.jpg",
    title: "Cheak Activewear",
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282659/l8op8gnx71mmhqgbbdrh.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282658/vvidkgnaww7ncy7ikvvl.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282658/jypb5anboq3wrwb14vkw.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282659/dbsoshpojja4f4zeghhh.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282659/hrbejxibeyk2kgxdxiw4.jpg",
    ],
  },
  {
    folder: "byredo",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282646/x5ccy5gupagayyz3yry2.avif",
    title: "Byredo Makeup",
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282646/azsbspcn6euvuhcbo3bt.avif",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282646/x5ccy5gupagayyz3yry2.avif",
    ],
  },
  {
    folder: "boycott",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282638/lurblb7maff33k1u86ca.jpg",
    title: "Boycott Magazine",
    filter: "editorial",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282638/lurblb7maff33k1u86ca.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282638/oextyw2drzctwxzk8tsl.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282638/yswq7hkfzxhbsslenc5b.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282638/szjta1leryr9xfeawbnp.jpg",
    ],
  },
  {
    folder: "bagaholic",
    path: "https://res.cloudinary.com/de1zyaayq/video/upload/v1764282610/IMG_0448_licszw.mp4",
    title: "Bagaholic Boy x Takashimaya",
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/video/upload/v1764282610/IMG_0448_licszw.mp4",
    ],
  },
  {
    folder: "another",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282555/wml8dhqavupdw3r2l4jg.jpg",
    title: "& Other Stories",
    filter: "lookbook",
    images: [
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282555/wml8dhqavupdw3r2l4jg.jpg",
      "https://res.cloudinary.com/de1zyaayq/image/upload/v1764282555/kpvdwpzqqob63t8fusjr.jpg",
    ],
  },
];

const DIGITALS = [
  {
    id: "1",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284395/w2fzpi0sn9dunjykobb2.jpg",
  },
  {
    id: "2",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284393/ry2erkxuqprvmavtbxqn.jpg",
  },
  {
    id: "3",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284392/lh5oj5smfj3c1g0n75ky.jpg",
  },
  {
    id: "4",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284390/qmfogwtododczgr9xsua.jpg",
  },
  {
    id: "5",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284385/svfuxngpukzyfusyfzk9.jpg",
  },
  {
    id: "6",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284383/egzlomlltygwndqayrba.jpg",
  },
  {
    id: "7",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284382/mxkqhc9ew1wwjeluwimn.jpg",
  },
  {
    id: "8",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284380/tawm62hy8mxvxqtdyczm.jpg",
  },
  {
    id: "9",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284378/zkwrcamtjdsvvbvhfawy.jpg",
  },
  {
    id: "10",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284377/l3xqcwlkytpjy24oahbj.jpg",
  },
  {
    id: "11",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284375/e2kd5uoigqdjsijamac4.jpg",
  },
  {
    id: "14",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284403/s3hmc9u6wpokwo9km1jl.jpg",
  },
  {
    id: "15",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284397/qmffq5b4fqg2u3i8xv5v.jpg",
  },
  {
    id: "16",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284402/x9avprsfwpdebosblwca.jpg",
  },
  {
    id: "17",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284400/ixxvoicb9wyipsxcwptr.jpg",
  },
  {
    id: "18",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284398/h5sclubpfi2902gqrr9d.jpg",
  },
  {
    id: "12",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284373/mcxjl0emurebrnk8v2et.jpg",
  },
  {
    id: "13",
    path: "https://res.cloudinary.com/de1zyaayq/image/upload/v1764284372/mlunyh9fthikuk0vyp9c.jpg",
  },
];

const SKILLS = {
  pytorch: "/images/pytorch.png",
  react: "/images/react.png",
  angular: "/images/angular.png",
  html: "/images/html.png",
  css: "/images/css.png",
  java: "/images/java.png",
  javascript: "/images/javascript.png",
  cplus: "/images/c++.png",
  typescript: "/images/typescript.png",
  spring: "/images/spring.png",
  python: "/images/python.png",
  sql: "/images/sql.png",
  numpy: "/images/numpy.png",
  pandas: "/images/pandas.png",
  scikitlearn: "/images/scikitlearn.png",
};

export { COVERIMAGES, DIGITALS, SKILLS };
